// Configurazione cache per l'applicazione
export const CACHE_CONFIG = {
  // Cache per gli escort
  ESCORTS: {
    KEY: 'escorts_cache',
    DURATION: 60 * 60 * 1000, // 1 ora in millisecondi
  },
  
  // Cache per le ricerche (per future implementazioni)
  SEARCH: {
    KEY: 'search_cache',
    DURATION: 30 * 60 * 1000, // 30 minuti
  },
  
  // Cache per le location (per future implementazioni)
  LOCATIONS: {
    KEY: 'locations_cache',
    DURATION: 24 * 60 * 60 * 1000, // 24 ore
  },
    // Cache per i dati SEO (per future implementazioni)
  SEO: {
    KEY: 'seo_cache',
    DURATION: 6 * 60 * 60 * 1000, // 6 ore
  },
  
  // Cache per la galleria immagini
  GALLERY: {
    KEY: 'gallery_cache',
    DURATION: 60 * 60 * 1000, // 1 ora
  }
} as const;

// Interfaccia generica per i dati in cache
export interface CacheData<T = any> {
  data: T;
  timestamp: number;
}

// Utility per gestire la cache generica
export class CacheManager {
  static get<T>(key: string): T | null {
    try {
      const cachedItem = localStorage.getItem(key);
      if (!cachedItem) return null;
      
      const cache: CacheData<T> = JSON.parse(cachedItem);
      return cache.data;
    } catch (error) {
      console.warn(`Errore durante il caricamento della cache ${key}:`, error);
      localStorage.removeItem(key);
      return null;
    }
  }
  
  static set<T>(key: string, data: T): void {
    try {
      const cache: CacheData<T> = {
        data,
        timestamp: Date.now()
      };
      localStorage.setItem(key, JSON.stringify(cache));
    } catch (error) {
      console.warn(`Errore durante il salvataggio della cache ${key}:`, error);
    }
  }
  
  static isExpired(key: string, duration: number): boolean {
    try {
      const cachedItem = localStorage.getItem(key);
      if (!cachedItem) return true;
      
      const cache: CacheData = JSON.parse(cachedItem);
      const now = Date.now();
      
      return (now - cache.timestamp) > duration;
    } catch (error) {
      return true;
    }
  }
  
  static remove(key: string): void {
    localStorage.removeItem(key);
  }
  
  static clear(): void {
    // Rimuove tutte le cache dell'app
    Object.values(CACHE_CONFIG).forEach(config => {
      localStorage.removeItem(config.KEY);
    });
  }
  
  static getAge(key: string): number | null {
    try {
      const cachedItem = localStorage.getItem(key);
      if (!cachedItem) return null;
      
      const cache: CacheData = JSON.parse(cachedItem);
      return Date.now() - cache.timestamp;
    } catch (error) {
      return null;
    }
  }
}
